import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { Tooltip } from '../../../../common/tooltip'

export const ItemHightLight = ({ text, isTooltip, textToolTip, children }) => {
  return (
    <div className="dFlex flexColumn justifyContentBetween alignItemsCenter ">
      <div className="dFlex textCenter">
        <Element
          className="dFlex"
          style={{
            fontSize: 14,
            fontWeight: 600,
            lineHeight: '16px',
            textTransform: 'uppercase',
            paddingRight: 4,
          }}
        >
          <Translate value={text} />
          {isTooltip && (
            <Tooltip
              tooltipContent={textToolTip}
              tooltipContentStyle={{ maxWidth: 600, textAlign: 'justify' }}
              isI18n
            >
              <Icon
                className="icon-info-circle"
                style={{ fontSize: 14, color: '#9C9C9C', marginLeft: 4 }}
              />
            </Tooltip>
          )}
        </Element>
      </div>
      <div>{children}</div>
    </div>
  )
}
